import React, { useEffect, useState } from 'react';
import { fetchAllConversations } from '../../api/ConversationApi';
import { Conversations } from '../model';
import ItemList from '../list/ItemList';

const Conversation: React.FC = () => {
  const [conversations, setConversations] = useState<Conversations[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchAllConversations()
      .then(setConversations)
      .catch(() => setError('Failed to load conversations'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  return (
    <ItemList
      items={conversations}
      linkPrefix="conversation"
      renderName={conversation => conversation.topic}
      renderStatus={conversation => conversation.type}
    />
  );
};

export default Conversation;
